// Firebase app initialization. Single instance, imported everywhere else.
//
// Local dev runs against **live** deployed Firebase — auth, Firestore, and the
// callables all point at the real project. The licence side-steps
// `generateLicense`'s deliberate refusal of `localhost` origins via a
// pre-minted, localhost-scoped JWT loaded from `VITE_DEV_LICENSE` in
// `.env.local`. See `src/composables/useLicense.ts` and `.env.example`, and
// TODO 0018 / `sketcher#0147` for the design.
//
// The emulator suite (`npm run dev:emulators`) is still a supported fallback
// for developers who cannot mint a dev licence; that path is documented in
// `CLAUDE.md` and `docs/host-app.md`.

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

import { firebaseConfig, FUNCTIONS_REGION } from './firebase-config'

export const app       = initializeApp(firebaseConfig)
export const auth      = getAuth(app)
export const db        = getFirestore(app)
export const functions = getFunctions(app, FUNCTIONS_REGION)
